<script setup>
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { provideDropdownContext } from './provider.js';

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);

const closeMenu = () => {
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});
</script>

<template>
  <div v-on-click-outside="closeMenu" class="relative space-y-2">
    <slot name="trigger" :is-open :toggle="() => toggle()" />
    <!-- advup: inset-x-0 dá ao wrapper a largura real do trigger (antes 0×0). Sem isso,
         o ltr:right-0 do DropdownBody ancorava na borda ESQUERDA do trigger (dropdown
         deslocado pra esquerda — ex: sino de notificações na navbar). Com inset-x-0:
         right-0 ancora na direita, left-0 na esquerda. Não muda dropdowns left-0. -->
    <!-- Entra e sai como todo flutuante da casa (24/10/2026, `.advup-pop`): era a única
         família de menus do produto que aparecia e sumia seca. -->
    <Transition name="advup-pop">
      <div v-if="isOpen" class="absolute inset-x-0 advup-pop">
        <slot />
      </div>
    </Transition>
  </div>
</template>
